export default {
    FETCHING_RETAILERS_CHANGED: 'FETCHING_RETAILERS_CHANGED'
};
